<template>
  <div
    class="flex text-sm mt-1 mb-1"
    :class="lastSlot? 'rounded-b-lg' : '' "
  >
    <div
      class="text-gray-600 leading-6 bg-white p-2 text-center border border-gray-300 font-semibold flex items-center justify-center mr-1 rounded-lg"
      :class="lastSlot? 'rounded-b-lg' : '' "
      style="width: 10%; min-width: 10%; max-width: 10%;"
    >
      {{ teeSlot.time | moment("HH:mm") }}
    </div>

    <div
      class="flex w-full"
    >
      <div
        v-for="(player, index) in players"
        :class="getContainerClass(player, index)"
        class="w-full flex"
      >
        <div
          v-if="player.index === 0 && index !== 0"
          class="w-1"
        />

        <div
          v-if="player.name !== 'System'"
          class="leading-none bg-white shadow-sm text-gray-700 w-full h-11 cursor-pointer hover:bg-gray-50 transition-all duration-500"
          :class="getPlayerClasses(player, index)"
          @click="openSlot"
        >
          <div
            class="w-full bg-gradient-to-b"
            style="height: 5px;"
            :class="getHeaderClasses(player, index)"
          />

          <div class="h-full flex items-center justify-between p-2 pl-3 pr-2 pt-0">
            <div>
              {{ player.name }}
            </div>

            <div
              :data-tip="mapType(player.type)"

              class="tool rounded-full text-xs w-6 h-6 leading-none select-none flex items-center justify-center text-gray-700 font-semibold cursor-default border"
            >
              {{ getTypeChar(player.type) }}
            </div>
          </div>
        </div>


        <div
          v-else
          class="transition-all duration-500 overflow-hidden shadow-sm flex justify-center items-center w-full leading-none h-11 bg-gray-50"
          :class="getPlayerClasses(player, index)"
          @click="openSlot"
        >
          <i
            class="fas fa-lock text-gray-500"
          />
        </div>


        <div
          v-if="(player.index + 1) === player.bookingPlayers && (index + 1) !== maxPlayers"
          class="w-1"
        />
      </div>


      <div
        v-for="index in remainingSpaces"
        class="flex w-full"
      >
        <div
          v-if="index === 1 && remainingSpaces !== maxPlayers"
          class="w-1"
        />
        <div
          class="transition-all duration-500 overflow-hidden shadow-sm flex justify-center items-center w-full leading-none h-11"
          :class="getSpaceClasses(index)"
          @click="bookSlot"
          @mouseover="mouseOver(index)"
          @mouseleave="mouseLeave(index)"
        >
          <i
            v-if="bookable"
            class="fas fa-plus-circle"
          />
          <i
            v-else
            class="fas fa-lock text-gray-500"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TeeTimeBookingModel } from '@/app/shared/components/panels/booking/classes';
import { MapType, GetTypeChar, GetTypeBackground } from '@/app/shared/services/playerService/playerService';

export default {
  name: 'SlotRow',

  components: {

  },

  props: {
    teeSlot: {
      type: Object,
      default: null,
    },
    maxPlayers: {
      type: Number,
      default: undefined,
    },
    lastSlot: {
      type: Boolean,
      default: false,
    },
    teeTimeToBook: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      playerHover: 0,
      currentDate: new Date(),
    };
  },

  computed: {
    isSelected() {
      if (this.teeTimeToBook !== null) {
        return this.teeTimeToBook.teeTime.time === this.teeSlot.time;
      }
      return false;
    },

    // isBlocked() {
    //   console.log(this.teeSlot.bookings[0].players.length);
    //   return this.teeSlot.bookings.length > 0 && this.teeSlot.bookings[0].players.length === this.teeSlot.maxPlayers && this.teeSlot.bookings[0].players[0].type === 'System';
    // },

    bookable() {
      if (new Date(this.teeSlot.time) < this.currentDate) {
        return false;
      }
      return true;
    },
    remainingSpaces() {
      return this.teeSlot.availability;
    },

    players() {
      const players = [];


      for (let y = 0; y < this.teeSlot.bookings.length; y++) {
        for (let i = 0; i < this.teeSlot.bookings[y].players.length; i++) {
          const player = this.teeSlot.bookings[y].players[i];
          players.push({
            name: player.name,
            type: player.type,
            bookingPlayers: this.teeSlot.bookings[y].players.length,
            index: i,
            bookingIndex: y,
          });
        }
      }

      return players;
    },
  },

  watch: {
    teeTimeToBook() {
      if (this.teeTimeToBook === null || !this.isSelected) {
        this.playerHover = 0;
      } else if (this.teeTimeToBook.numOfPlayers !== this.playerHover) {
        this.playerHover = this.teeTimeToBook.numOfPlayers;
      }
    },

    'teeTimeToBook.numOfPlayers': function () {
      if (this.teeTimeToBook !== null && this.isSelected && this.teeTimeToBook.numOfPlayers !== this.playerHover) {
        this.playerHover = this.teeTimeToBook.numOfPlayers;
      }
    },
  },

  methods: {
    // getTypeBackground(type) {
    //   return GetTypeBackground(type);
    // },

    getTypeChar(type) {
      return GetTypeChar(type);
    },

    mapType(type) {
      return MapType(type);
    },

    mouseOver(index) {
      this.playerHover = index;
    },

    mouseLeave(index) {
      if (this.teeTimeToBook === null || !this.isSelected) {
        this.playerHover = 0;
      } else {
        this.playerHover = this.teeTimeToBook.numOfPlayers;
      }
    },

    bookSlot() {
      if (this.bookable) {
        this.$emit('book', new TeeTimeBookingModel(this.teeSlot, this.playerHover));
        // this.playerHover = 0;
      }
    },

    openSlot() {
      this.$emit('book', new TeeTimeBookingModel(this.teeSlot, 0));
    },

    getHeaderClasses(player) {
      let classes = ' ';

      classes += `${GetTypeBackground(player.type)} `;

      if (player.index === 0) {
        classes += 'rounded-tl-lg ';
      }

      if ((player.index + 1) === player.bookingPlayers) {
        classes += 'rounded-tr-lg ';
      }

      return classes;
    },

    getPlayerClasses(player) {
      let classes = ' ';

      if (player.index === 0) {
        classes += 'rounded-l-lg border-t border-l border-b ';
      }

      if ((player.index + 1) === player.bookingPlayers) {
        classes += 'rounded-r-lg border ';
      }

      if (player.index !== 0 && player.index !== player.bookingPlayers) {
        classes += 'border-t border-b ';
        classes += player.bookingPlayers > 2 ? 'border-l ' : '';
      }

      return classes;
    },

    getContainerClass(player, index) {
      let classes = ' ';

      if ((player.index + 1) === player.bookingPlayers) {
        classes += ' ';
      }

      return classes;
    },

    getSpaceClasses(index) {
      let classes = ' ';

      if (this.bookable) {
        classes += 'cursor-pointer ';
      }

      if (this.playerHover < index) {
        classes += 'bg-gray-50 text-gray-400 ';
      } else if (this.bookable) {
        if (this.isSelected) {
          classes += 'bg-gray-700 text-white border-gray-700 ';
        } else {
          classes += 'bg-cool-gray-200 text-gray-500 ';
        }
      } else {
        classes += 'bg-gray-50 text-gray-400 ';
      }

      if (index === 1) {
        classes += 'rounded-l-lg border ';
        if (index !== this.remainingSpaces) {
          classes += 'border-r-0 ';
        }
      }

      if (index !== 1 && index < this.remainingSpaces) {
        classes += 'border-t border-b border-l ';
      }

      if (index === this.remainingSpaces) {
        classes += 'border rounded-r-lg ';
      }

      return classes;
    },

  },
};
</script>
